var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27171 10.6968V12.5701C5.27171 13.0568 5.53837 13.5101 5.96504 13.7435L9.29837 15.5635C9.69837 15.7835 10.1784 15.7835 10.5784 15.5635L13.9117 13.7435C14.3384 13.5101 14.605 13.0568 14.605 12.5701V10.6968L10.5784 12.8968C10.1784 13.1168 9.69837 13.1168 9.29837 12.8968L5.27171 10.6968ZM9.29837 4.2568L3.67837 7.32347C3.21837 7.5768 3.21837 8.24347 3.67837 8.4968L9.29837 11.5635C9.69837 11.7835 10.1784 11.7835 10.5784 11.5635L15.9384 8.6368V12.5768C15.9384 12.9435 16.2384 13.2435 16.605 13.2435C16.9717 13.2435 17.2717 12.9435 17.2717 12.5768V8.30347C17.2717 8.0568 17.1384 7.8368 16.925 7.7168L10.5784 4.2568C10.1784 4.04347 9.69837 4.04347 9.29837 4.2568Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolWhite);
export default __webpack_public_path__ + "static/media/school_white.f97de456bd511938e852b73bf328d500.svg";
export { ForwardRef as ReactComponent };